import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=9965ced8&scoped=true&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=9965ced8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965ced8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
